import {Controller} from "@hotwired/stimulus"

// Reveals the `field` target(s) when the source <select> value is "other".
export default class extends Controller {
    static targets = ["source", "field"]

    connect() {
        this.toggle()
    }

    toggle() {
        const show = this.hasSourceTarget && this.sourceTarget.value === "other"
        this.fieldTargets.forEach((el) => el.classList.toggle("d-none", !show))
    }
}
